import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { prefetchLandingCardRoute } from "../../utils/routePrefetch";

const PREFETCH_DELAY_MS = 90;

const resolveHref = (target) => {
  const anchor = target?.closest?.("a[href]");
  if (!anchor) return "";
  try {
    const url = new URL(anchor.href, window.location.origin);
    if (url.origin !== window.location.origin) return "";
    return `${url.pathname}${url.search}`;
  } catch {
    return "";
  }
};

export function PublicRoutePrefetcher() {
  const location = useLocation();

  useEffect(() => {
    let timer;
    const schedule = (event, immediate = false) => {
      const href = resolveHref(event.target);
      if (!href || href.split("?", 1)[0] === location.pathname) return;
      if (timer) window.clearTimeout(timer);
      if (immediate) {
        void prefetchLandingCardRoute(href);
        return;
      }
      timer = window.setTimeout(() => {
        timer = undefined;
        void prefetchLandingCardRoute(href);
      }, PREFETCH_DELAY_MS);
    };
    const cancel = () => {
      if (timer) window.clearTimeout(timer);
      timer = undefined;
    };
    const onPointerOver = (event) => schedule(event, false);
    const onPointerOut = (event) => {
      const fromAnchor = event.target?.closest?.("a[href]");
      const toAnchor = event.relatedTarget?.closest?.("a[href]");
      if (fromAnchor && fromAnchor === toAnchor) return;
      cancel();
    };
    const onFocusIn = (event) => schedule(event, true);
    const onTouchStart = (event) => schedule(event, true);
    document.addEventListener("pointerover", onPointerOver, { passive: true });
    document.addEventListener("pointerout", onPointerOut, { passive: true });
    document.addEventListener("focusin", onFocusIn);
    document.addEventListener("touchstart", onTouchStart, { passive: true });
    return () => {
      cancel();
      document.removeEventListener("pointerover", onPointerOver);
      document.removeEventListener("pointerout", onPointerOut);
      document.removeEventListener("focusin", onFocusIn);
      document.removeEventListener("touchstart", onTouchStart);
    };
  }, [location.pathname]);

  return null;
}

export default PublicRoutePrefetcher;
